module.exports = __webpack_public_path__ + "images/blog/blog_card/questions/37_5bdcb270355a379391dff5f811d968ae.jpg";